import React from 'react';
import {Link} from 'react-router-dom';
import Moment from 'react-moment';
import 'moment-timezone';
import Navigation from '../Navigation';
import Carousel from '../Carousel';
import DescCut from "./DescCut";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClock, faStar } from '@fortawesome/free-solid-svg-icons'
import logo from '../../images/new_logo.svg';
import loading from '../../images/loading.png';
import { isNotEmpty } from "../../util/user";
import renderIf from "render-if";
import { faLinkedin, faFacebook, faAngellist, faTwitter, faInstagram } from '@fortawesome/free-brands-svg-icons'
import { faBell, faMoneyBillAlt, faEnvelope } from '@fortawesome/free-regular-svg-icons'
import {Editor, Modifier, ContentState, RichUtils, CompositeDecorator, getDefaultKeyBinding, convertFromHTML, convertToRaw, EditorState, AtomicBlockUtils} from 'draft-js';
import {stateToHTML} from 'draft-js-export-html';
import { composeDecorators } from 'draft-js-plugins-editor';
import createImagePlugin from 'draft-js-image-plugin';
import Helmet from "react-helmet";

import createAlignmentPlugin from 'draft-js-alignment-plugin';

import createFocusPlugin from 'draft-js-focus-plugin';

import createResizeablePlugin from 'draft-js-resizeable-plugin';

import createBlockDndPlugin from 'draft-js-drag-n-drop-plugin';

// import createDragNDropUploadPlugin from 'draft-js-drag-n-drop-upload-plugin';
const focusPlugin = createFocusPlugin();
const resizeablePlugin = createResizeablePlugin();
const blockDndPlugin = createBlockDndPlugin();
const alignmentPlugin = createAlignmentPlugin();
const { AlignmentTool } = alignmentPlugin;

const decorator = composeDecorators(
  resizeablePlugin.decorator,
  alignmentPlugin.decorator,
  focusPlugin.decorator,
  blockDndPlugin.decorator
);
const imagePlugin = createImagePlugin({ decorator });

const plugins = [
  blockDndPlugin,
  focusPlugin,
  alignmentPlugin,
  resizeablePlugin,
  imagePlugin
];

export default class FullCustomPage extends React.Component {
  constructor(props) {
    super(props);
    let listing;
    let listingId;
    let routed;
    let keysLength = Object.keys(props).length;

    const decorator = new CompositeDecorator([
      {
        strategy: findLinkEntities,
        component: Link
      }
    ]);

    if (keysLength === 0) {
      listing = undefined;
      routed = false;
      listingId = undefined;
    } else {
      if (props.match && props.match.path == "/posts/:id") {
        listing = undefined;
        routed = true;
        listingId = props.match.params.id;
      } else {
        listing = props.listing;
        routed = false;
        listingId = window.location.pathname;
      }
    }

    this.state = {
      mounted: false,
      editView: false,
      listing: listing,
      listingId: listingId,
      routed: routed,
      isNew: false,
      newtitle: "",
      newslug: "",
      newdescription: "",
      newkeywords: "",
      loading: true,
      propertyImages: [],
      errorMessage: undefined,
      showURLInput: false,
      url: "",
      urlType: "",
      showModal: false,
      savedListing: false,
      email: "",
      fullName: "",
      phone: "",
      notifyMessage: undefined,
      htmlBody: "",
      editorState: EditorState.createEmpty(),
      linkShowURLInput: false,
      linkUrlValue: "",
      title: "",
      slug: "",
      keywords: "",
      description: ""
    }

    // const state = this;
    this.onChange = (editorState) => {
      return this.setState({
        editorState
      })
      // console.log(state.refs.editor.refs.editor.innerHTML);
      //
      // this.setState({
      //   htmlBody: state.refs.editor.refs.editor.innerHTML
      // })
    }
    this.setEditor = (editor) => {
      this.editor = editor;
    };
    this.focusEditor = () => {
      if (this.editor) {
        this.editor.focus();
      }
    };
    this.focus = () => this.refs.editor.focus();
    this.handleKeyCommand = this._handleKeyCommand.bind(this);
    this.mapKeyToEditorCommand = this._mapKeyToEditorCommand.bind(this);
    this.toggleBlockType = this._toggleBlockType.bind(this);
    this.toggleInlineStyle = this._toggleInlineStyle.bind(this);
    this.viewCustomPage = this.viewCustomPage.bind(this);
    this.changeImage = this.changeImage.bind(this);
    this.sendForm = this.sendForm.bind(this);
    this.updateFullName = this.updateFullName.bind(this);
    this.updateEmail = this.updateEmail.bind(this);
    this.updatePhone = this.updatePhone.bind(this);
    this.updateMessage = this.updateMessage.bind(this);
    this.hideMessageCtn = this.hideMessageCtn.bind(this);
    this.editCustomPage = this.editCustomPage.bind(this);
    this.createCustomPage = this.createCustomPage.bind(this);
    this.toggleColor = toggledColor => this._toggleColor(toggledColor);
    this.onURLChange = e => this.setState({ urlValue: e.target.value });
    this.onTitleChange = e => this.setState({ title: e.target.value });
    this.onSlugChange = e => this.setState({ slug: e.target.value });
    this.onNewTitleChange = e => this.setState({ newtitle: e.target.value });
    this.onNewSlugChange = e => this.setState({ newslug: e.target.value });
    this.onNewDescriptionChange = e => this.setState({ newdescription: e.target.value });
    this.onNewKeywordsChange = e => this.setState({ newkeywords: e.target.value });
    this.onDescriptionChange = e => this.setState({ description: e.target.value });
    this.onKeywordsChange = e => this.setState({ keywords: e.target.value });

    this.addAudio = this._addAudio.bind(this);
    this.addImage = this._addImage.bind(this);
    this.addVideo = this._addVideo.bind(this);
    this.confirmMedia = this._confirmMedia.bind(this);
    this.onURLInputKeyDown = this._onURLInputKeyDown.bind(this);
    this.promptForLink = this._promptForLink.bind(this);
    this.confirmLink = this._confirmLink.bind(this);
    this.onLinkInputKeyDown = this._onLinkInputKeyDown.bind(this);
    this.removeLink = this._removeLink.bind(this);
  }

  _promptForLink(e) {
    e.preventDefault();
    const { editorState } = this.state;
    const selection = editorState.getSelection();
    if (!selection.isCollapsed()) {
      const contentState = editorState.getCurrentContent();
      const startKey = editorState.getSelection().getStartKey();
      const startOffset = editorState.getSelection().getStartOffset();
      const blockWithLinkAtBeginning = contentState.getBlockForKey(startKey);
      const linkKey = blockWithLinkAtBeginning.getEntityAt(startOffset);
      let url = "";
      if (linkKey) {
        const linkInstance = contentState.getEntity(linkKey);
        url = linkInstance.getData().url;
      }
      this.setState(
        {
          linkShowURLInput: true,
          linkUrlValue: url
        },
        () => {
          setTimeout(() => this.refs.url.focus(), 0);
        }
      );
    }
  }
  _confirmLink(e) {
    e.preventDefault();
    const { editorState, urlValue } = this.state;
    const contentState = editorState.getCurrentContent();
    const contentStateWithEntity = contentState.createEntity(
      "LINK",
      "MUTABLE",
      { url: urlValue }
    );
    const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
    const newEditorState = EditorState.set(editorState, {
      currentContent: contentStateWithEntity
    });
    this.setState(
      {
        editorState: RichUtils.toggleLink(
          newEditorState,
          newEditorState.getSelection(),
          entityKey
        ),
        linkShowURLInput: false,
        linkUrlValue: ""
      },
      () => {
        setTimeout(() => this.refs.editor.focus(), 0);
      }
    );
  }
  _onLinkInputKeyDown(e) {
    if (e.which === 13) {
      this._confirmLink(e);
    }
  }
  _removeLink(e) {
    e.preventDefault();
    const { editorState } = this.state;
    const selection = editorState.getSelection();
    if (!selection.isCollapsed()) {
      this.setState({
        editorState: RichUtils.toggleLink(editorState, selection, null)
      });
    }
  }

  _confirmMedia(e) {
    e.preventDefault();
    const { editorState, urlValue, urlType } = this.state;
    const contentState = editorState.getCurrentContent();
    const contentStateWithEntity = contentState.createEntity(
      urlType,
      "IMMUTABLE",
      { src: urlValue }
    );
    const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
    const newEditorState = EditorState.set(editorState, {
      currentContent: contentStateWithEntity
    });
    this.setState(
      {
        editorState: AtomicBlockUtils.insertAtomicBlock(
          newEditorState,
          entityKey,
          " "
        ),
        showURLInput: false,
        urlValue: ""
      },
      () => {
        setTimeout(() => this.focus(), 0);
      }
    );
  }
  _onURLInputKeyDown(e) {
    if (e.which === 13) {
      this._confirmMedia(e);
    }
  }
  _promptForMedia(type) {
    this.setState(
      {
        showURLInput: true,
        urlValue: "",
        urlType: type
      },
      () => {
        setTimeout(() => this.refs.url.focus(), 0);
      }
    );
  }

  _addAudio() {
    this._promptForMedia("audio");
  }
  _addImage() {
    this._promptForMedia("image");
  }
  _addVideo() {
    this._promptForMedia("video");
  }

  _handleKeyCommand(command, editorState) {
    const newState = RichUtils.handleKeyCommand(editorState, command);
    if (newState) {
      this.onChange(newState);
      return true;
    }
    return false;
  }

  _toggleColor(toggledColor) {
    const { editorState } = this.state;
    const selection = editorState.getSelection();
    // Let's just allow one color at a time. Turn off all active colors.
    const nextContentState = Object.keys(colorStyleMap).reduce(
      (contentState, color) => {
        return Modifier.removeInlineStyle(contentState, selection, color);
      },
      editorState.getCurrentContent()
    );
    let nextEditorState = EditorState.push(
      editorState,
      nextContentState,
      "change-inline-style"
    );
    const currentStyle = editorState.getCurrentInlineStyle();
    // Unset style override for current color.
    if (selection.isCollapsed()) {
      nextEditorState = currentStyle.reduce((state, color) => {
        return RichUtils.toggleInlineStyle(state, color);
      }, nextEditorState);
    }
    // If the color is being toggled on, apply it.
    if (!currentStyle.has(toggledColor)) {
      nextEditorState = RichUtils.toggleInlineStyle(
        nextEditorState,
        toggledColor
      );
    }
    this.onChange(nextEditorState);
  }

  _mapKeyToEditorCommand(e) {
    if (e.keyCode === 9 /* TAB */) {
      const newEditorState = RichUtils.onTab(
        e,
        this.state.editorState,
        4 /* maxDepth */
      );
      if (newEditorState !== this.state.editorState) {
        this.onChange(newEditorState);
      }
      return;
    }
    return getDefaultKeyBinding(e);
  }
  _toggleBlockType(blockType) {
    this.onChange(RichUtils.toggleBlockType(this.state.editorState, blockType));
  }
  _toggleInlineStyle(inlineStyle) {
    this.onChange(
      RichUtils.toggleInlineStyle(this.state.editorState, inlineStyle)
    );
  }

  hideMessageCtn() {
    this.setState({
      notifyMessage: undefined
    });
  }

  updateEmail(e) {
    const state = this;

    this.setState({
      email: e.target.value
    })
  }

  updatePhone(e) {
    const state = this;

    this.setState({
      phone: e.target.value
    })
  }

  updateMessage(e) {
    const state = this;

    this.setState({
      message: e.target.value
    })
  }

  updateFullName(e) {
    const state = this;

    this.setState({
      fullName: e.target.value
    })
  }

  viewCustomPage(id) {
    let listingID = id !== undefined ? id : this.state.listingId;
    listingID = listingID.split("/").slice(-1)[0];
    const state = this;

    if (listingID !== undefined && isNotEmpty(listingID)) {

      const token = localStorage.getItem("auth_token");
      var myHeaders = new Headers({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      });

      var myInit = {
        method: 'GET',
        headers: myHeaders
      };

      var myRequest = new Request(`${process.env.REACT_APP_API_HOST}/api/custom_pages/${listingID}`, myInit);

      fetch(myRequest)
      .then((json) => json.json())
      .then((content) => {
        let custom_page = content.custom_page;
        const html = custom_page.body
        const blocksFromHTML = convertFromHTML(html)
        let contentState = ContentState.createFromBlockArray(blocksFromHTML)

        state.setState({
          listing: custom_page,
          title: custom_page.title,
          slug: custom_page.slug,
          propertyImages: [],
          mounted: true,
          loading: false,
          htmlBody: html,
          editorState: EditorState.createWithContent(contentState)
        });

        return content;
      });
    } else {
      let html = "<div>Edit a new post</div>"
      const blocksFromHTML = convertFromHTML(html)
      let contentState = ContentState.createFromBlockArray(blocksFromHTML)

      state.setState({
        mounted: true,
        loading: false,
        htmlBody: html,
        editorState: EditorState.createWithContent(contentState)
      });
    }
  }

  editCustomPage(id) {
    let listingID = id !== undefined ? id : this.state.listing.id;
    const state = this;

    const contentState = this.state.editorState.getCurrentContent();
    // let rawState = convertToRaw(contentState)

    // console.log('rawState', rawState)
    // console.log('rawState', JSON.stringify(rawState))
    let html = stateToHTML(contentState);

    let values = {};
    values = Object.assign({}, values, {
      body: html,
      slug: this.state.slug,
      title: this.state.title,
      description: this.state.description,
      keywords: this.state.keywords
    });

    const token = localStorage.getItem("auth_token");
    var myHeaders = new Headers({
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`
    });

    var myInit = {
      method: 'PUT',
      headers: myHeaders,
      body: JSON.stringify(values)
    };

    var myRequest = new Request(`${process.env.REACT_APP_API_HOST}/api/custom_pages/${listingID}`, myInit);

    fetch(myRequest)
    .then((json) => json.json())
    .then((content) => {
      let custom_page = content.custom_page;
      const html = custom_page.body
      const blocksFromHTML = convertFromHTML(html)
      let contentState = ContentState.createFromBlockArray(blocksFromHTML)

      state.setState({
        listing: custom_page,
        title: custom_page.title,
        slug: custom_page.slug,
        propertyImages: [],
        mounted: true,
        loading: false,
        htmlBody: html,
        editorState: EditorState.createWithContent(contentState)
      });

      return content;
    });
  }

  createCustomPage() {
    const state = this;

    const contentState = this.state.editorState.getCurrentContent();
    // let rawState = convertToRaw(contentState)

    // console.log('rawState', rawState)
    // console.log('rawState', JSON.stringify(rawState))
    let html = stateToHTML(contentState);

    let values = {};
    values = Object.assign({}, values, {
      body: html,
      slug: this.state.newslug,
      title: this.state.newtitle,
      description: this.state.newdescription,
      keywords: this.state.newkeywords
    });

    const token = localStorage.getItem("auth_token");
    var myHeaders = new Headers({
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`
    });

    var myInit = {
      method: 'POST',
      headers: myHeaders,
      body: JSON.stringify(values)
    };

    var myRequest = new Request(`${process.env.REACT_APP_API_HOST}/api/custom_pages`, myInit);

    fetch(myRequest)
    .then((json) => json.json())
    .then((content) => {
      let custom_page = content.custom_page;
      const html = custom_page.body
      const blocksFromHTML = convertFromHTML(html)
      let contentState = ContentState.createFromBlockArray(blocksFromHTML)

      state.setState({
        listing: custom_page,
        title: custom_page.title,
        slug: custom_page.slug,
        propertyImages: [],
        mounted: true,
        loading: false,
        htmlBody: html,
        editorState: EditorState.createWithContent(contentState)
      });

      return content;
    });
  }

  componentDidMount() {
    this.viewCustomPage();
    this.focusEditor();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.match !== undefined) {
      if(this.props.match.params.id !== nextProps.match.params.id) {
        this.viewCustomPage(nextProps.match.params.id)
      }
    }
  }

  changeImage(image) {
    this.setState({currentImage: image.Image})
  }

  sendForm() {
    const state = this;

    let values = {};
    values = Object.assign({}, values, {
      message: this.state.message,
      phone: this.state.phone,
      email: this.state.email,
      full_name: this.state.fullName,
    });

    (async () => {
      const token = localStorage.getItem("auth_token");
      var myHeaders = new Headers({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      });

      var myInit = {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(values)
      };
      var myRequest = new Request(`${process.env.REACT_APP_API_HOST}/api/general_messages/`, myInit);

      const rawResponse = await fetch(myRequest)
      const content = await rawResponse.json();

      state.setState({
        notifyMessage: "Successful message. We will contact you shortly! :)"
      });

      setTimeout(() => {
        state.setState({
          notifyMessage: undefined
        })
      }, 7000)

      return content;
    })();
  }

  render() {
    let urlInput;
    if (this.state.showURLInput) {
      urlInput = (
        <div style={styles.urlInputContainer}>
          <input
            onChange={this.onURLChange}
            ref="url"
            style={styles.urlInput}
            type="text"
            value={this.state.urlValue}
            onKeyDown={this.onURLInputKeyDown}
          />
          <button onMouseDown={this.confirmMedia}>Confirm</button>
        </div>
      );
    }

    let linkUrlInput;
    if (this.state.linkShowURLInput) {
      linkUrlInput = (
        <div style={styles.urlInputContainer}>
          <input
            onChange={this.onURLChange}
            ref="url"
            style={styles.urlInput}
            type="text"
            value={this.state.linkUrlValue}
            onKeyDown={this.onLinkInputKeyDown}
          />
          <button onMouseDown={this.confirmLink}>Confirm</button>
        </div>
      );
    }

    let listing = this.state.listing || undefined;
    const currentImage = listing ? this.state.currentImage : ""
    const { editorState } = this.state

    const notify = this.state.notifyMessage;
    let notifyDetail = <div></div>

    if (notify !== undefined) {
        notifyDetail = <div onClick={this.hideMessageCtn} className="notification-ctn notify">
          {notify}
        </div>
    }

    let firstImage = undefined

    if (listing !== undefined) {
      var elem = document.createElement('div');
      elem.style.display = 'none';
      document.body.appendChild(elem);
      elem.innerHTML = listing.body;
      firstImage = elem.querySelector('img')
    }

    if (!isNotEmpty(firstImage)) {
      firstImage = "https://besthamiltonhouses.com/static/media/logo.df977010.png"
    } else {
      firstImage = firstImage.src
    }

    let titleLink = `/browse`
    if (listing && listing.title) {
      titleLink = `/browse?title=${listing.title}`
    }

    let mailLink;
    let twittertext;
    let facebooktext;
    let linkedintext;

    if (listing !== undefined) {
      mailLink = `mailto:example@gmail.com?subject=${listing.title}body=${window.location.href}`
      twittertext = `https://twitter.com/intent/tweet?text=${window.location.href}`
      facebooktext = `https://www.facebook.com/sharer.php?u=${window.location.href}`
      linkedintext = `https://www.linkedin.com/shareArticle?mini=true&url=${window.location.href}`
    }

    let nonAdmin = <div className="job-outline">
      {listing && (
        <div className="full-job-details-stacked listing-page full-custom-page">
          <div className="heading">
            <h2>{listing.title}</h2>
          </div>

          <div className="images">
            <div className="current-image">
              <img src={firstImage} />
            </div>

            <div className="social-media">
            <a href={twittertext} target="_blank"><FontAwesomeIcon icon={faTwitter} /></a>
            <a href={linkedintext} target="_blank"><FontAwesomeIcon icon={faLinkedin} /></a>
            <a href={facebooktext} target="_blank"><FontAwesomeIcon icon={faFacebook} /></a>
            <a href={mailLink} target="_blank"><FontAwesomeIcon icon={faEnvelope} /></a>
            </div>
          </div>

          <div className="listing-info">
            <div className="content">
              <h2 className="heading">
                <Link className="black-font" to={titleLink}>Get {listing.title} Listings</Link>
              </h2>

              <section>
                <h2 className="small-heading">{listing.title}</h2>
                <div className="blog-remarks">
                  <DescCut
                    truncate={false}
                    id={listing.id}
                    description={listing.body}/>
                </div>
              </section>
            </div>
          </div>

          <div className="contact-form">
            <h2 className="small-heading centered">Contact Us About {listing.title}</h2>

            <div className="inputs">
              <div className="input-form">
                <div className="label">
                  Full Name
                </div>

                <input onChange={this.updateFullName.bind(this)} value={this.state.fullName} className="input"></input>
              </div>

              <div className="input-form half-form first-form">
                <div className="label">
                  Email address
                </div>

                <input onChange={this.updateEmail.bind(this)} value={this.state.email} className="input"></input>
              </div>

              <div className="input-form half-form">
                <div className="label">
                  Phone
                </div>

                <input onChange={this.updatePhone.bind(this)} value={this.state.phone} className="input"></input>
              </div>

              <div className="input-form">
                <div className="label">
                  Message
                </div>

                <textarea onChange={this.updateMessage.bind(this)} value={this.state.message} className="input"></textarea>
              </div>

              <div onClick={() => this.sendForm()} className="button">
                Save
              </div>
            </div>
          </div>

          <div className="full-listing-idx">
            <img src="https://s3.amazonaws.com/staticos.idxbroker.com/mls-logos/b579-logoURL-idxsandbox" alt="" />

            <div className="text">
              © 2019 REALTORS® Association of Hamilton-Burlington (RAHB). All rights reserved. The data relating to real estate for sale on this web site comes in part from the Internet Data Exchange Program of RAHB. Real estate listings held by IDX Brokerage firms other than Prosession Homes are marked with the Internet Data Exchange logo or the Internet Data Exchange thumbnail logo and detailed information about them includes the name of the listing Brokers. Information provided is deemed reliable but not guaranteed. 
            </div>

            <br />
            <br />
          </div>
        </div>
      )}
    </div>

    if (this.props.admin) {
      let className = "RichEditor-editor";
      var contentState = editorState.getCurrentContent();
      if (!contentState.hasText()) {
        if (
          contentState
            .getBlockMap()
            .first()
            .getType() !== "unstyled"
        ) {
          className += " RichEditor-hidePlaceholder";
        }
      }

      nonAdmin = <div>
        {!listing &&
          <div id="loading-state"><img src={loading} /></div>
        }

        {listing && (
          <div className="full-job-details-stacked admin-listing listing-page full-custom-page">
            <div className="heading">
              <h2>Edit {listing.title}</h2>
            </div>

            <div className="inputs">
              Edit Title: <input
                onChange={this.onTitleChange}
                style={styles.urlInput}
                type="text"
                value={this.state.title}
              />
              <br />

              Edit Alias: <input
                onChange={this.onSlugChange}
                style={styles.urlInput}
                type="text"
                value={this.state.slug}
              />
              <br />

              Edit Description: <input
                onChange={this.onDescriptionChange}
                style={styles.urlInput}
                type="text"
                value={this.state.description}
              />
              <br />

              Edit Keywords: <input
                onChange={this.onKeywordsChange}
                style={styles.urlInput}
                type="text"
                value={this.state.keywords}
              />
              <br />
            </div>

            <div className="listing-info">
              <div style={styles.editor} onClick={this.focusEditor}>
                <div className="RichEditor-root">
                  <BlockStyleControls
                    editorState={editorState}
                    onToggle={this.toggleBlockType}
                  />
                  <InlineStyleControls
                    editorState={editorState}
                    onToggle={this.toggleInlineStyle}
                  />
                  <div style={styles.buttons}>
                    <button onMouseDown={this.addAudio} style={{ marginRight: 10 }}>
                      Add Audio
                    </button>
                    <button onMouseDown={this.addImage} style={{ marginRight: 10 }}>
                      Add Image
                    </button>
                    <button onMouseDown={this.addVideo} style={{ marginRight: 10 }}>
                      Add Video
                    </button>
                  </div>
                  {urlInput}

                  <div style={styles.buttons}>
                    <button onMouseDown={this.promptForLink} style={{ marginRight: 10 }}>
                      Add Link
                    </button>
                    <button onMouseDown={this.removeLink}>Remove Link</button>
                  </div>
                  {linkUrlInput}
                  <div style={styles.editor} onClick={this.focus}>
                    <Editor
                      blockRendererFn={mediaBlockRenderer}
                      blockStyleFn={getBlockStyle}
                      customStyleMap={styleMap}
                      editorState={editorState}
                      plugins={plugins}
                      handleKeyCommand={this.handleKeyCommand}
                      keyBindingFn={this.mapKeyToEditorCommand}
                      onChange={this.onChange}
                      placeholder="Tell a story..."
                      ref="editor"
                      spellCheck={true}
                    />

                    <AlignmentTool />
                  </div>
                </div>
              </div>
            </div>

            <div onClick={() => this.editCustomPage(this.state.listing.id)} className="button">
              Send
            </div>
          </div>
        )
        }
      </div>
    }

    let isNew = false;
    if (window.location.pathname.includes("/new")) {
      isNew = true
    }

    if (isNew) {
      nonAdmin =
        <div className="full-job-details-stacked admin-listing listing-page full-custom-page">
          <div className="heading">
            <h2>Edit {this.state.newtitle}</h2>
          </div>

          <div className="inputs">
            Edit Title: <input
              onChange={this.onNewTitleChange}
              style={styles.urlInput}
              type="text"
              value={this.state.newtitle}
            />
            <br />

            Edit Alias: <input
              onChange={this.onNewSlugChange}
              style={styles.urlInput}
              type="text"
              value={this.state.newslug}
            />
            <br />

            Edit Description: <input
              onChange={this.onNewDescriptionChange}
              style={styles.urlInput}
              type="text"
              value={this.state.newdescription}
            />
            <br />

            Edit Keywords: <input
              onChange={this.onNewKeywordsChange}
              style={styles.urlInput}
              type="text"
              placeholder="Comma separated"
              value={this.state.newkeywords}
            />
            <br />
          </div>

          <div className="listing-info">
            <div style={styles.editor} onClick={this.focusEditor}>
              <div className="RichEditor-root">
                <BlockStyleControls
                  editorState={editorState}
                  onToggle={this.toggleBlockType}
                />
                <InlineStyleControls
                  editorState={editorState}
                  onToggle={this.toggleInlineStyle}
                />
                <div style={styles.buttons}>
                  <button onMouseDown={this.addAudio} style={{ marginRight: 10 }}>
                    Add Audio
                  </button>
                  <button onMouseDown={this.addImage} style={{ marginRight: 10 }}>
                    Add Image
                  </button>
                  <button onMouseDown={this.addVideo} style={{ marginRight: 10 }}>
                    Add Video
                  </button>
                </div>
                {urlInput}

                <div style={styles.buttons}>
                  <button onMouseDown={this.promptForLink} style={{ marginRight: 10 }}>
                    Add Link
                  </button>
                  <button onMouseDown={this.removeLink}>Remove Link</button>
                </div>
                {linkUrlInput}
                <div style={styles.editor} onClick={this.focus}>
                  <Editor
                    blockRendererFn={mediaBlockRenderer}
                    blockStyleFn={getBlockStyle}
                    customStyleMap={styleMap}
                    editorState={editorState}
                    plugins={plugins}
                    handleKeyCommand={this.handleKeyCommand}
                    keyBindingFn={this.mapKeyToEditorCommand}
                    onChange={this.onChange}
                    placeholder="Tell a story..."
                    ref="editor"
                    spellCheck={true}
                  />

                  <AlignmentTool />
                </div>
              </div>
            </div>
          </div>

          <div onClick={() => this.createCustomPage()} className="button">
            Send
          </div>
        </div>
    }

    return (
      <div className="full-job-ctn">
        {listing && (
          <Helmet>
            <title>{'Hamilton Homes - ' + listing.title}</title>
            <meta name="description" content={listing.description}/>
            <meta name="keywords" content={"buying,communities,ancaster,stoney creek,niagara,waterdown, grimsby, burlington, Flamborough, dundas, brantford, hamilton,homes,for,sale,niburski,search,condos,luxury,business" + listing.keywords}/>

            <meta property="og:url" content={"https://besthamiltonhouses.com/posts" + listing.slug}/>
            <meta property="og:title" content={"Hamilton Homes - " + listing.title}/>
            <meta property="og:description" content={listing.description}/>
          </Helmet>
        )}

        {nonAdmin}

        {notifyDetail}
      </div>
    )
  }
}

function mediaBlockRenderer(block) {
  if (block.getType() === "atomic") {
    return {
      component: Media,
      editable: false
    };
  }
  return null;
}
const Audio = props => {
  return <audio controls src={props.src} style={styles.media} />;
};
const Image = props => {
  return <img src={props.src} style={styles.media} />;
};
const Video = props => {
  return <video controls src={props.src} style={styles.media} />;
};
const Media = props => {
  const entity = props.contentState.getEntity(props.block.getEntityAt(0));
  const { src } = entity.getData();
  const type = entity.getType().toLowerCase();

  let media = null;
  if (type === "audio") {
    media = <Audio src={src} />;
  } else if (type === "image") {
    media = <Image src={src} />;
  } else if (type === "video") {
    media = <Video src={src} />;
  }
  return media;
};

function findLinkEntities(contentBlock, callback, contentState) {
  contentBlock.findEntityRanges(character => {
    const entityKey = character.getEntity();
    return (
      entityKey !== null &&
      contentState.getEntity(entityKey).getType() === "LINK"
    );
  }, callback);
}

const LinkVal = props => {
  const { url } = props.contentState.getEntity(props.entityKey).getData();
  return (
    <a href={url} style={styles.link}>
      {props.children}
    </a>
  );
};

const styleMap = {
  CODE: {
    backgroundColor: "rgba(0, 0, 0, 0.05)",
    fontFamily: '"Inconsolata", "Menlo", "Consolas", monospace',
    fontSize: 16,
    padding: 2
  }
};
function getBlockStyle(block) {
  switch (block.getType()) {
    case "blockquote":
      return "RichEditor-blockquote";
    default:
      return null;
  }
}
class StyleButton extends React.Component {
  constructor() {
    super();
    this.onToggle = e => {
      e.preventDefault();
      this.props.onToggle(this.props.style);
    };
  }
  render() {
    let className = "RichEditor-styleButton";
    if (this.props.active) {
      className += " RichEditor-activeButton";
    }
    return (
      <span className={className} onMouseDown={this.onToggle}>
        {this.props.label}
      </span>
    );
  }
}
const BLOCK_TYPES = [
  { label: "H1", style: "header-one" },
  { label: "H2", style: "header-two" },
  { label: "H3", style: "header-three" },
  { label: "H4", style: "header-four" },
  { label: "H5", style: "header-five" },
  { label: "H6", style: "header-six" },
  { label: "Blockquote", style: "blockquote" },
  { label: "UL", style: "unordered-list-item" },
  { label: "OL", style: "ordered-list-item" },
  { label: "Code Block", style: "code-block" }
];
const BlockStyleControls = props => {
  const { editorState } = props;
  const selection = editorState.getSelection();
  const blockType = editorState
    .getCurrentContent()
    .getBlockForKey(selection.getStartKey())
    .getType();
  return (
    <div className="RichEditor-controls">
      {BLOCK_TYPES.map(type => (
        <StyleButton
          key={type.label}
          active={type.style === blockType}
          label={type.label}
          onToggle={props.onToggle}
          style={type.style}
        />
      ))}
    </div>
  );
};
var INLINE_STYLES = [
  { label: "Bold", style: "BOLD" },
  { label: "Italic", style: "ITALIC" },
  { label: "Underline", style: "UNDERLINE" },
  { label: "Monospace", style: "CODE" }
];
const InlineStyleControls = props => {
  const currentStyle = props.editorState.getCurrentInlineStyle();

  return (
    <div className="RichEditor-controls">
      {INLINE_STYLES.map(type => (
        <StyleButton
          key={type.label}
          active={currentStyle.has(type.style)}
          label={type.label}
          onToggle={props.onToggle}
          style={type.style}
        />
      ))}
    </div>
  );
};

var COLORS = [
  { label: "Red", style: "red" },
  { label: "Orange", style: "orange" },
  { label: "Yellow", style: "yellow" },
  { label: "Green", style: "green" },
  { label: "Blue", style: "blue" },
  { label: "Indigo", style: "indigo" },
  { label: "Violet", style: "violet" }
];
const ColorControls = props => {
  var currentStyle = props.editorState.getCurrentInlineStyle();
  return (
    <div style={styles.controls}>
      {COLORS.map((type, index) => (
        <StyleButton
          active={currentStyle.has(type.style)}
          label={type.label}
          key={index}
          onToggle={props.onToggle}
          style={type.style}
        />
      ))}
    </div>
  );
};
// This object provides the styling information for our custom color
// styles.
const colorStyleMap = {
  red: {
    color: "rgba(255, 0, 0, 1.0)"
  },
  orange: {
    color: "rgba(255, 127, 0, 1.0)"
  },
  yellow: {
    color: "rgba(180, 180, 0, 1.0)"
  },
  green: {
    color: "rgba(0, 180, 0, 1.0)"
  },
  blue: {
    color: "rgba(0, 0, 255, 1.0)"
  },
  indigo: {
    color: "rgba(75, 0, 130, 1.0)"
  },
  violet: {
    color: "rgba(127, 0, 255, 1.0)"
  }
};
const styles = {
  editor: {
    border: '1px solid gray',
    minHeight: '6em'
  },
  root: {
    fontFamily: "'Georgia', serif",
    fontSize: 14,
    padding: 20,
    width: 600
  },
  editor: {
    borderTop: "1px solid #ddd",
    cursor: "text",
    fontSize: 16,
    marginTop: 20,
    minHeight: 400,
    paddingTop: 20
  },
  urlInputContainer: {
    marginBottom: 10
  },
  urlInput: {
    fontFamily: "'Georgia', serif",
    marginRight: 10,
    padding: 3
  },
  editor: {
    border: "1px solid #ccc",
    cursor: "text",
    minHeight: 80,
    padding: 10
  },
  button: {
    marginTop: 10,
    textAlign: "center"
  },
  link: {
    color: "#3b5998",
    textDecoration: "underline"
  },
  controls: {
    fontFamily: "'Helvetica', sans-serif",
    fontSize: 14,
    marginBottom: 10,
    userSelect: "none"
  },
  styleButton: {
    color: "#999",
    cursor: "pointer",
    marginRight: 16,
    padding: "2px 0"
  },
  root: {
    fontFamily: "'Georgia', serif",
    padding: 20,
    width: 600
  },
  buttons: {
    marginBottom: 10
  },
  urlInputContainer: {
    marginBottom: 10
  },
  urlInput: {
    fontFamily: "'Georgia', serif",
    marginRight: 10,
    padding: 3
  },
  editor: {
    border: "1px solid #ccc",
    cursor: "text",
    minHeight: 80,
    padding: 10
  },
  button: {
    marginTop: 10,
    textAlign: "center"
  },
  media: {
    width: "100%",
    // Fix an issue with Firefox rendering video controls
    // with 'pre-wrap' white-space
    whiteSpace: "initial"
  }
};
